import { Card, CardSlim, DictionaryPaths, DictionarySlim, NamedMode } from "./Common"
import { TrainingStat } from "./StatTypes"

export enum TrainingType {
    Auto,
    Interpret,
    Choice,
    Combined,
    Main,
}

export enum ServicePanelVisibility {
    None,
    Interpret,
    InterpretAndCombined,
    Always,
    InterpretAndOnMistake,
}

export enum TaskKind {
    PhrasePronunciationForms,
    PhrasePronunciation,
    PhraseForms,
    Phrase,
    PronunciationPhraseForms,
    PronunciationPhrase,
    PronunciationForms,
    Pronunciation,
}

export interface SimilarCard extends Card {
    similar?: CardSlim[] | undefined
}

export interface TrainingCardData {
    card: TrainingCard | undefined,
    isSolutionShown: boolean,
}

export interface CardOption {
    content: string,
    contentAux: string,
    wrongOption: string,
    card: TrainingCard,
    width: number
}

export enum InterpretValue {
    DoNotKnow = 0,
    NotSure,
    Know,
    KnowWell,
    Reset,
    MinimalDecrease,
    MinimalIncrease,
    KnowExcellent
}
export enum ChoiceValue {
    Incorrect = 0,
    Correct,
    Decrease,
    Know
}

//response

export interface TrainingResponse {
    cardsData: CardsData,
    trainingStat: TrainingStat
}

export interface CardsData {
    cards: TrainingCard[],
    modeInfo: ModeInfo,
    cardsInfo: string,
}

export interface TrainingCard extends Card {
    options: TrainingCard[] | undefined,
    similar: SimilarCardSlim[] | undefined,
    trainingType: TrainingType,
    isPreview: boolean,
    modeInfo: ModeInfo,
    resultInfo: ResultInfo,
}

export interface SimilarCardSlim extends CardSlim {
    dictionaryName: string | undefined
}

export interface ModeInfo extends DictionaryPaths {
    dictionaryId: number,
    dictionaryName: string,
    isDirect: boolean,
    isPreview: boolean,
    isHard: boolean,
    isEditable: boolean,
    isInMix: boolean,
    modeSetting: ModeSettingSlim,
}

export interface ResultInfo {
    id: number,
    info: string,
    isOnHold: boolean,
    reviews: number,
    isWeak: boolean,
}
//end response

export interface UserModesSettings {
    mixedActive: boolean,
    single: ModeSetting,
    mixed: NamedMode[] | undefined,
    mixedModesLimit: number,
    dictionaries: DictionarySlim[]
}

export interface ModeSetting extends ModeSettingSlim {
    dictionaryId: number,
    isDirect: boolean,
    dictionaryName: string,
}

export interface ModeSettingSlim {
    newCardsDailyLimit: number,
    newCardsRandomOrder: boolean,
    taskKind: TaskKind
}